// extracted by mini-css-extract-plugin
export default {"root":"Highlights-root","title":"Highlights-title","list":"Highlights-list","item":"Highlights-item"};